import {Flex, Badge, theme, useTheme, FlexProps} from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import {Event, Place} from '../../../types/article';
import Icon from '../../Icon';
import {TextG10} from '../../typography';

interface PointBoostBadgeProps extends FlexProps {
  article: Place | Event;
  flexDir?: FlexProps['flexDir'];
  alignItems?: FlexProps['alignItems'];
}

const PointBoostBadge = ({article, flexDir = 'row', alignItems = 'center'}: PointBoostBadgeProps) => {
  const theme = useTheme();

  const boostStarted = dayjs().utc().isAfter(article.points_boost_starts_at);
  const boostNotEnded = !dayjs().utc().isAfter(article.points_boost_ends_at);
  const pointsBoostAmount = article.points_boost_amount;

  const pointBoostIsActive =
    article.is_points_boost_active &&
    pointsBoostAmount &&
    pointsBoostAmount > 0 &&
    boostStarted &&
    boostNotEnded;

  if (!pointBoostIsActive) {
    return null;
  }

  return (
    <Flex gap="4px" flexDir={flexDir} alignItems={alignItems} my="4px">
      <Badge
        w="fit-content"
        textTransform="none"
        color="#E02F84"
        bg="#FFEDF6"
        borderRadius="4px"
        px="4px"
        py="4px">
        <Flex flexDir="row" gap="2px" alignItems="center">
          <Icon iconName="fi-rr-angle-double-small-up" style={{width: '12px', height: '12px'}} />
          <TextG10 fontWeight={700} color={theme.colors.rose}>
            Points Boost
          </TextG10>
        </Flex>
      </Badge>
      <Flex flexDir="row" gap="3px" whiteSpace="nowrap">
        <TextG10
          fontWeight="500"
          color={theme.colors.rose}>{`+${pointsBoostAmount.toLocaleString()} Points`}</TextG10>
        <TextG10> when you check-in here!</TextG10>
      </Flex>
    </Flex>
  );
};

export default PointBoostBadge;
